import { render, staticRenderFns } from "./AccountSwitch.vue?vue&type=template&id=7aad48b9&"
import script from "./AccountSwitch.vue?vue&type=script&lang=ts&"
export * from "./AccountSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports